import React, { useEffect, useState } from "react";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import { CircularProgress } from "@mui/material";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import useDownloader from "react-use-downloader";
import toast from "react-hot-toast";
import { checkStatusAuditReport } from "../../../../sevices/leadComplianceApi";

function DownloadUnitSurveyForm({ building_id, unit_number, unit_id, api, ll55 = false }) {
  const { download, error, isInProgress } = useDownloader();
  const [year] = useCustomSearchParams("year");
  const [loading, setLoading] = useState(false);

  const storageKey = `survey-form-${building_id}-${unit_id}-${year}`;
  const [isGenerating, setIsGenerating] = useState(!!localStorage.getItem(storageKey));
  const [pdfId, setPdfId] = useState(localStorage.getItem(storageKey) || null);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const pdfBase = `${baseUrl}${ll55 ? "" : "/pdf/"}`;

  useEffect(() => {
    const savedId = localStorage.getItem(storageKey);
    setIsGenerating(!!savedId);
    setPdfId(savedId);
  }, [storageKey]);

  useEffect(() => {
    let interval;

    if (pdfId && isGenerating) {
      interval = setInterval(async () => {
        checkStatusAuditReport(pdfId)
          .then((res) => {
            const taskStatus = res.data.data?.task_status || res.data.status;
            const fileName =
              res.data.data?.file_name ||
              res.data.data?.pdf_file_path ||
              res.data.file_name ||
              res.data.pdf_file_path;
            const message = res.data.data?.message || res.data.message;

            if (taskStatus === "completed") {
              clearInterval(interval);
              const downloadUrl = ll55
                ? `${baseUrl}${fileName}`
                : `${baseUrl}/pdf/${fileName}`;
              download(downloadUrl, `survey-form-${unit_number}.pdf`);
              setIsGenerating(false);
              setPdfId(null);
              localStorage.removeItem(storageKey);
            } else if (taskStatus === "failed") {
              toast.error(message || "PDF generation failed");
              clearInterval(interval);
              setIsGenerating(false);
              setPdfId(null);
              localStorage.removeItem(storageKey);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, 6000);
    }

    return () => clearInterval(interval);
  }, [pdfId, isGenerating, baseUrl, ll55, storageKey, unit_number, download]);

  const startDownload = () => {
    if (isGenerating) return;
    setLoading(true);
    setIsGenerating(true);
    api({
      building_id,
      unit_id,
      year,
      download_and_send: false,
    })
      .then((res) => {
        const taskId = res.data.task_id;

        if (taskId) {
          setPdfId(taskId);
          localStorage.setItem(storageKey, taskId);
          setLoading(false);
        } else {
          download(
            `${pdfBase}${
              ll55 ? res.data.pdf_file_path : res.data
            }`,
            `survey-form-${unit_number}.pdf`
          );
          setLoading(false);
          setIsGenerating(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response?.data?.message || "Failed to start download");
        setLoading(false);
        setIsGenerating(false);
      });
  };

  useEffect(() => {
    if (error) {
      toast.error("Download failed. Please try again.");
    }
  }, [error]);

  const isDownloading = isGenerating || isInProgress;

  return (
    <div>
      {year == new Date().getFullYear() && (
        <div className="inline-flex items-center">
          {isDownloading ? (
            <CircularProgress size={20} />
          ) : (
            <SimCardDownloadIcon
              fontSize="medium"
              className="cursor-pointer"
              color="action"
              onClick={startDownload}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default DownloadUnitSurveyForm;